import { useUserEnvStore } from '@/common/stores/user-env';
import { useDashboardUserEnvStore } from '@/dashboard/stores/dashboard-user-env';
import type { GridSettingEnvValue } from '../../modernGrid.types';

/**
 * @param useDashboard true이면 dashboard user env 스토어 사용(대시보드 위젯용). 미설정 시 공통 meta user env 사용
 */
export const useEnvStore = (useDashboard = false) => {
  const getEnvStore = useDashboard ? useDashboardUserEnvStore : useUserEnvStore;

  const getEnv = (key: string | undefined): any | null => {
    if (!key) return null;
    const envStore = getEnvStore();
    return envStore.getEnvValue(key);
  };

  const saveEnv = async (key: string | undefined, value: GridSettingEnvValue) => {
    if (!key) return;
    const payload = [{ key, value }];
    const envStore = getEnvStore();
    await envStore.setEnvValue(payload);
  };

  const clearEnv = async (key: string | undefined) => {
    if (!key) return;
    const envStore = getEnvStore();
    await envStore.clearUserEnvValue(key, true, true);
  };

  return {
    getEnv,
    saveEnv,
    clearEnv,
  };
};
